module.exports = __webpack_public_path__ + "img/kapila-siriwardhana-leccturing-04-small.c58d1f6a.jpg";